// extracted by mini-css-extract-plugin
module.exports = {"overlay":"MatchupInviteWatcher_overlay__lEH6X"};